import { call, put, takeEvery } from "redux-saga/effects";

// Chat Redux States
import { GET_EVENTS } from "./actionTypes";
import { hideEventsLoader, setEvents, showEventsLoader } from "./actions";

import { getEvents } from "../../helpers/jwt_helper";

function* onGetEvents({payload: data = {}}) {
  // console.log(data);
  try {
    yield put(showEventsLoader())
    let response = yield call(getEvents, {
      tracker_app_id: data.tracker_app_id,
    })

    response = response.map(i => ({...i, value: i.id, label: i.event_name}))

    yield put(setEvents(response))
    yield put(hideEventsLoader())
  } catch (error) {
    yield put(hideEventsLoader())
  }
}

function* eventsSaga() {
  yield takeEvery(GET_EVENTS, onGetEvents)
}

export default eventsSaga
